
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Prop, Vue } from "vue-property-decorator";
import { BgDialog } from "@banggood/scm-fe";
@Component({
  components: {
    BgDialog,
  },
})
export default class PdfPreviewer extends Vue {
  @Prop() visible!: boolean;
  @Prop() url!: string;
  @Prop({ required: false, default: "文件预览" }) title?: string;
  @Prop({ required: false, default: true }) online?: boolean;
  get src(): string {
    if (this.online) {
      return `./pdf/viewer.html?file=${this.url}`;
    }
    return this.url;
  }
  close() {
    this.$emit("update:visible", false);
    this.$emit("close");
  }
}
